import { EventEmitter } from '@angular/core';

export class GalleryFilesConfig {
  // se emite cada vez que se realiza una accion con los botones de la tabla
  accion: EventEmitter<any> = new EventEmitter();
  // contiene la configuracion de la tabla
  settings = {};

  constructor () {
    this.settings = {
      mode: 'external',
      noDataMessage: 'No hay archivos subidos.',
      actions: false,
      attr: {
        class: 'table-bordered table-hover'
      },
      columns: {
        name: {
          title: 'Nombre del archivo',
          editable: false,
        },
        size: {
          title: 'Tamaño',
          editable: false,
        },
      },
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/examples/gallery-files/shared/gallery-files.config.service.ts